// src/pages/AcceptInviteLink/AcceptInviteLink.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { acceptGroupInviteLink } from '../../api/groupApi';
import { useToast } from '../../components/Toaster/use-toast';
import { stashPendingInvite } from '../../utils/pendingInvites';


export default function AcceptGroupInviteLink() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get('token');
  const { toast } = useToast();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let alive = true;

    async function run() {
      if (!token) {
        setStatus('error');
        setMessage('Missing invite token.');
        return;
      }

      try {
        const res = await acceptGroupInviteLink(token);
        if (!alive) return;
        setStatus('ok');
        setMessage(`You’ve joined "${res.groupName}" in ${res.orgName}.`);
        setTimeout(() => navigate('/conversation-type', { replace: true }), 1200);
      } catch (e) {
        if (!alive) return;

        const code = e?.response?.data?.code;
        const err = e?.response?.data?.error || e?.message || 'Could not accept invite link.';

        if (code === 'LOGIN_REQUIRED') {
          stashPendingInvite({ token, mode: 'link' });

          navigate('/auth', { replace: true });
          return;
        }

        setStatus('error');
        setMessage(err);
      }
    }

    run();
    return () => { alive = false; };
  }, [token, navigate]);

  return (
    <div style={{ padding: 24, maxWidth: 520, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 8 }}>
        {status === 'loading' ? 'Joining group…' : status === 'ok' ? 'Welcome!' : 'Invite link problem'}
      </h2>
      <div style={{ opacity: 0.8 }}>{message}</div>
    </div>
  );
}
